// Shared class sets for the quiet restyle. Full class names are written out
// here (Tailwind's scanner needs them literal), so a component composes
// `ui.btnPrimary` rather than restating fifteen utilities.

export const ui = {
  // Buttons: one filled primary per screen; everything else text or outline.
  btnPrimary: 'inline-flex items-center justify-center gap-1.5 h-9 px-3.5 rounded-ctl bg-accent text-white text-body font-medium hover:bg-accent-strong disabled:opacity-50 disabled:cursor-not-allowed transition-colors whitespace-nowrap',
  btnOutline: 'inline-flex items-center justify-center gap-1.5 h-9 px-3 rounded-ctl border border-line bg-surface text-body text-ink hover:bg-accent-tint hover:border-accent/40 disabled:opacity-50 transition-colors whitespace-nowrap',
  btnText: 'inline-flex items-center justify-center gap-1.5 h-9 px-2.5 rounded-ctl text-body text-ink hover:bg-accent-tint disabled:opacity-50 transition-colors whitespace-nowrap',
  btnDanger: 'inline-flex items-center justify-center gap-1.5 h-9 px-3.5 rounded-ctl border border-flag-red text-flag-red text-body font-medium hover:bg-flag-red/5 transition-colors whitespace-nowrap',
  iconBtn: 'inline-flex items-center justify-center w-9 h-9 rounded-ctl text-ink-2 hover:bg-accent-tint hover:text-ink transition-colors',
  link: 'text-accent hover:underline',

  // Small status chips are the one place a pill radius is allowed.
  chip: 'inline-flex items-center gap-1 px-2 py-px rounded-full border border-line text-meta font-medium text-ink-2 whitespace-nowrap',
  chipAccent: 'inline-flex items-center gap-1 px-2 py-px rounded-full border border-accent bg-surface text-meta font-medium text-accent whitespace-nowrap',
  chipRed: 'inline-flex items-center gap-1 px-2 py-px rounded-full border border-flag-red text-meta font-medium text-flag-red whitespace-nowrap',

  // Surfaces
  card: 'card bg-surface border-line rounded-card',
  panel: 'bg-surface border border-line rounded-card',
  menu: 'absolute right-0 mt-1.5 min-w-[15rem] bg-surface border border-line rounded-card shadow-pop py-1 z-50',
  menuItem: 'w-full px-3.5 py-2 text-left text-body text-ink hover:bg-accent-tint flex items-center gap-2.5 transition-colors',

  // Fields
  input: 'w-full h-9 px-3 rounded-card border border-line bg-surface text-body text-ink placeholder:text-ink-2/70 outline-none focus:border-accent focus:ring-2 focus:ring-accent/25',
  textarea: 'w-full px-3 py-2 rounded-card border border-line bg-surface text-body text-ink placeholder:text-ink-2/70 outline-none focus:border-accent focus:ring-2 focus:ring-accent/25',
  select: 'h-9 px-2.5 rounded-card border border-line bg-surface text-body text-ink outline-none focus:border-accent',

  // Text
  label: 'text-meta font-medium uppercase tracking-wide text-ink-2',
  meta: 'text-meta text-ink-2',
  heading: 'text-heading font-medium text-ink',
};

// Lab result flags: a 6 px dot in the semantic colour plus the flag word.
export const FLAG_TONE = {
  high: 'text-flag-red',
  low: 'text-flag-amber',
  abn: 'text-flag-amber',
  ok: 'text-flag-green',
  pending: 'text-flag-pending',
};
export const FLAG_DOT = {
  high: 'bg-flag-red',
  low: 'bg-flag-amber',
  abn: 'bg-flag-amber',
  ok: 'bg-flag-green',
  pending: 'bg-flag-pending',
};
export const FLAG_LABELS = { high: 'HIGH', low: 'LOW', abn: 'ABN', ok: 'NL', pending: 'PEND' };
